import React from 'react';
import dayjs from 'dayjs';
import { Popconfirm, Space } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
 faTrash, faEdit, faCheckCircle, faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';

import styles from './Clientes.module.less';

const relativeTime = require('dayjs/plugin/relativeTime');

dayjs.extend(relativeTime);

const commonColumns = (t, viewClient) => [
  {
    width: '16%',
    title: 'Celcia ID',
    dataIndex: 'celsia_id',
    render: (celsia_id) => celsia_id || '-',
  },
  {
    width: '16%',
    title: 'Third ID',
    dataIndex: 'third_id',
    render: (third_id) => third_id || '-',
  },
  {
    width: '16%',
    title: t('tables.users.columns.description'),
    dataIndex: 'description',
    render: (description) => description || '-',
  },
  {
    width: '16%',
    title: t('forms.clients.labels.community_rep'),
    dataIndex: 'representative',
    // eslint-disable-next-line
    render: (representative) => (representative ? <FontAwesomeIcon className={styles.faOK} icon={faCheckCircle} /> : <FontAwesomeIcon className={styles.faERROR} icon={faTimesCircle} />),
  },
  {
    width: '16%',
    title: t('tables.devices.columns.business_type'),
    dataIndex: 'business_type_name',
    render: (business_type_name) => business_type_name || '-',
  },
  {
    width: '16%',
    title: t('tables.users.columns.devices'),
    dataIndex: 'devices_total',
    render: (devices_total) => devices_total || '-',
  },
  {
    width: '10%',
    title: t('tables.users.columns.information'),
    render: (_, record) => ( // view datails
      // eslint-disable-next-line react/jsx-filename-extension
      <div
        onClick={() => viewClient(record)}
        onKeyDown={() => viewClient(record)}
        role="link"
        tabIndex={0}
      >
        <span
          style={{
            color: '#828282',
            borderBottom: '1px solid #828282',
            cursor: 'pointer',
          }}
        >
          {t('tables.users.columns.view')}
        </span>
      </div>
    ),
  },
];

const columnsClientes = (t, currentUser, deleteClient, editClient, viewClient) => {

  const isAdmin = currentUser.role === 'Superadmin' || currentUser.role === 'Admin';

  const columns = commonColumns(t, viewClient);

if (isAdmin) {

columns.push(
{
key: 'has_missing_data_alarm_rule',
width: '10%',
title: '',
dataIndex: 'id',
render: (_, record) => ( // edit users
  // eslint-disable-next-line react/jsx-filename-extension
  <Space>
    <div className={styles.btnsIcon} style={{ marginRight: 5 }}>
      <FontAwesomeIcon
        icon={faEdit}
        className={styles.faIcons}
        onClick={() => editClient(record)}
      />
    </div>

    <div className={styles.btnsIcon} style={{ marginLeft: 5 }}>
      <Popconfirm
        title={t('views.dynamic_alarms.feedbacks.delete_alarms.confirm_title')}
        okText={t('views.dynamic_alarms.feedbacks.delete_alarms.confirm_ok')}
        cancelText={t('views.dynamic_alarms.feedbacks.delete_alarms.confirm_cancel')}
        onConfirm={() => deleteClient(record)}
      >
        <FontAwesomeIcon className={styles.faIcons} icon={faTrash} />
      </Popconfirm>
    </div>
  </Space>
),
},

);

}

  return columns;

};

export default columnsClientes;
